export default __webpack_public_path__ + "static/media/lofus.ebd6055b.jpg";